export const FONT_FAMILY = 'Helvetica';
export const BaseURL = process.env.REACT_APP_BASE_URL;
export const ProductionBaseURL = process.env.REACT_APP_PRODUCTION_BASE_URL;

export const desktopNavLinks = [
  {
    title: 'Forum',
    slug: 'https://optionsgeek.com/forum/?p=categories',
    bgColor: '#019934',
  },
  {
    title: 'Home',
    slug: 'https://optionsgeek.com/welcome-home-page/',
    bgColor: 'rgb(0,111,176)',
  },
];

export const mobileSubnavLinks = [
  { label: 'UOA', url: '/unusualoptionsactivity' },
  { label: 'Stock', url: '/stocks', accessLevel: 'fullaccess' },
  { label: 'Chain', url: '/optionschain' },
  { label: 'OI', url: '/openinterest', accessLevel: 'fullaccess' },
  {
    label: 'Watchlist',
    url: '/watchlist',
    style: { width: '48%', paddingTop: '5px' },
    accessLevel: 'fullaccess',
  },
];

export const navbarMobileSubMenuLinks = [
  {
    title: 'Top 1 % Club',
    url: 'https://optionsgeek.com/top-1-club-members-area/',
  },
  {
    title: '3 Steps to Profit',
    url: 'https://optionsgeek.com/3-steps-to-profit/',
  },
  {
    title: 'Winning Picks',
    url: 'https://optionsgeek.com/best-options-trading-alert-service/',
  },
  {
    title: 'WP eBook',
    url: 'https://optionsgeek.com/best-options-trading-strategy/',
  },
  {
    title: '1-on-1 Coaching',
    url: 'https://optionsgeek.com/options-trading-coaching/',
  },
];

export const optionTradeTableHeaderCells = [
  {
    title: 'Size',
    sortKey: 'size',
    bgColor: 'black',
  },
  {
    title: 'Ticker',
    sortKey: 'ticker',
  },
  {
    title: 'Expiry',
    sortKey: 'expiry',
  },
  {
    title: 'Strike',
    sortKey: 'strike',
  },
  {
    title: 'P/C',
    sortKey: 'option',
  },
  {
    title: 'Price',
    sortKey: 'price',
  },
  {
    title: 'Side',
    sortKey: 'mktside',
  },
  {
    title: 'Stock',
    sortKey: 'spot',
  },
  {
    title: 'Chg',
    sortKey: 'spot_chg',
  },
  {
    title: 'Condition',
    sortKey: 'condition',
  },
  {
    title: 'Volume',
    sortKey: 'volume',
  },
  {
    title: 'OI',
    sortKey: 'open_int',
  },
  {
    title: 'IV',
    sortKey: 'ivol',
  },
  {
    title: 'Chg',
    sortKey: 'ivol_chg',
  },
  {
    title: 'Delta',
    sortKey: 'delta',
  },
  {
    title: 'Time',
    sortKey: 'timestamp',
  },
];



// WEBPACK FOOTER //
// ./src/constants/index.js